var render, staticRenderFns
import script from "./TestsPerPhysician.vue?vue&type=script&lang=js&"
export * from "./TestsPerPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d3448b')) {
      api.createRecord('61d3448b', component.options)
    } else {
      api.reload('61d3448b', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/trending-charts/TestsPerPhysician.vue"
export default component.exports